import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Row, Col, List, Button } from '@gympass/yoga'
import Container from '@components/Container'

import * as Style from './EmployeeInvestment.style'

export default function EmployeeInvestment() {
  return (
    <Style.EmployeeInvestmentWrapper>
      <Container>
        <Row>
          <Col xxs={12}>
            <Style.Title>
              <FormattedMessage id="smb_acquisition_commercial_offer.benefits.employee.title" />
            </Style.Title>
            <Style.Subtitle>
              <FormattedMessage id="smb_acquisition_commercial_offer.benefits.employee.subtitle" />
            </Style.Subtitle>
          </Col>
        </Row>

        <Row>
          <Col xxs={12} md={6}>
            <Style.ListWrapper>
              <List divided={false}>
                <Style.ListItem>
                  <Style.ListIcon />
                  <Style.ListItemDescription>
                    <FormattedMessage id="smb_acquisition_commercial_offer.benefits.employee.benefit_1.description" />
                  </Style.ListItemDescription>
                </Style.ListItem>

                <Style.ListItem>
                  <Style.ListIcon />
                  <Style.ListItemDescription>
                    <FormattedMessage id="smb_acquisition_commercial_offer.benefits.employee.benefit_2.description" />
                  </Style.ListItemDescription>
                </Style.ListItem>

                <Style.ListItem>
                  <Style.ListIcon />
                  <Style.ListItemDescription>
                    <FormattedMessage id="smb_acquisition_commercial_offer.benefits.employee.benefit_3.description" />
                  </Style.ListItemDescription>
                </Style.ListItem>

                <Style.ListItem>
                  <Style.ListIcon />
                  <Style.ListItemDescription>
                    <FormattedMessage id="smb_acquisition_commercial_offer.benefits.employee.benefit_4.description" />
                  </Style.ListItemDescription>
                </Style.ListItem>
              </List>
            </Style.ListWrapper>

            <Row>
              <Col xxs={12} md={6} xl={4}>
                <Style.ButtonWrapper>
                  <Button
                    href="https://hs.gympass.com/hubfs/Commercial%20Offer%20BR/membership_br.pdf"
                    target="_blank"
                    rel="noopener noreferrer"
                    full
                  >
                    <FormattedMessage id="smb_acquisition_commercial_offer.media.plans_download" />
                  </Button>
                </Style.ButtonWrapper>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </Style.EmployeeInvestmentWrapper>
  )
}
